import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import SmartComponent from '../../../SmartComponent'
import { resolveItemTaskIds } from '../helpers'

const isPlainObject = (value) => !!value && typeof value === 'object' && !Array.isArray(value)

function EmbeddedItemSupplemental ({ item, taskComponent }) {
  const taskIds = useMemo(() => resolveItemTaskIds(item), [item])

  const configOverrides = useMemo(() => {
    const base = isPlainObject(taskComponent?.configOverrides) ? taskComponent.configOverrides : {}
    return { ...base, filterIds: taskIds ?? [] }
  }, [taskIds, taskComponent?.configOverrides])

  if (!taskComponent?.blueprintCode || !taskComponent?.presentationKey) return null
  // Hide entirely when there are no linked tasks (either no field, or explicit empty array).
  if (!taskIds || taskIds.length === 0) return null

  const containerStyle = isPlainObject(taskComponent.containerStyle) ? taskComponent.containerStyle : undefined

  return (
    <div style={containerStyle}>
      <SmartComponent
        blueprintCode={taskComponent.blueprintCode}
        presentationKey={taskComponent.presentationKey}
        styleVariant={taskComponent.styleVariant}
        configOverrides={configOverrides}
      />
    </div>
  )
}

EmbeddedItemSupplemental.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    taskIds: PropTypes.array,
    tasks: PropTypes.array
  }).isRequired,
  taskComponent: PropTypes.shape({
    blueprintCode: PropTypes.string,
    presentationKey: PropTypes.string,
    styleVariant: PropTypes.string,
    configOverrides: PropTypes.object,
    containerStyle: PropTypes.object
  })
}

export default EmbeddedItemSupplemental
